export const findValue = (valueToSearch, searchWord) => {
  const trimmedSearchWord = searchWord.trim().toLowerCase()
  return valueToSearch.toLowerCase().includes(trimmedSearchWord)
}
